import * as chrono from 'chrono-node'
import { PERIOD_KEYWORDS } from '../../date/periodKeywords'
import type { LanguagePack } from './types'

/**
 * „halb 3“ und „viertel nach 3“ meinen am Nachmittag 14:30 und 15:15 — niemand plant 2:30 Uhr nachts.
 * Bis 6 Uhr wird darum der Nachmittag angenommen.
 */
function afternoonIfEarly(hour: number): number {
  return hour <= 6 ? hour + 12 : hour
}

const NOT_WORD_BEFORE = '(?<![\\p{L}\\p{N}])'
const NOT_WORD_AFTER = '(?![\\p{L}\\p{N}])'

/*
  Was chrono-node auf Deutsch nicht kennt (gemessen 02.10.2026): „halb 10“, „viertel nach 3“,
  „viertel vor 4“ und „am 3.10.“ ohne Jahr. Die eingebauten Muster bleiben; diese kommen dazu.
*/
const deChrono = chrono.de.casual.clone()
deChrono.parsers.push(
  {
    pattern: () => new RegExp(`${NOT_WORD_BEFORE}halb\\s+(\\d{1,2})${NOT_WORD_AFTER}`, 'iu'),
    extract: (_context, match) => {
      const hour = Number(match[1])
      if (hour < 1 || hour > 24) return null
      return { hour: afternoonIfEarly(hour - 1), minute: 30 }
    },
  },
  {
    pattern: () => new RegExp(`${NOT_WORD_BEFORE}viertel\\s+(nach|vor)\\s+(\\d{1,2})${NOT_WORD_AFTER}`, 'iu'),
    extract: (_context, match) => {
      const hour = Number(match[2])
      if (hour < 1 || hour > 24) return null
      return match[1]!.toLowerCase() === 'nach'
        ? { hour: afternoonIfEarly(hour), minute: 15 }
        : { hour: afternoonIfEarly(hour - 1), minute: 45 }
    },
  },
  {
    // „am 3.10.“ — mit Jahr („3.10.2026“) kennt chrono-node es selbst.
    pattern: () => new RegExp(`${NOT_WORD_BEFORE}(?:am\\s+)?(\\d{1,2})\\.(\\d{1,2})\\.(?![\\p{N}])`, 'iu'),
    extract: (_context, match) => {
      const day = Number(match[1])
      const month = Number(match[2])
      if (day < 1 || day > 31 || month < 1 || month > 12) return null
      return { day, month }
    },
  },
)

export const de: LanguagePack = {
  chrono: deChrono,
  deadlineWords: ['bis'],
  durationLeads: ['für'],
  durationUnits: {
    m: 1, min: 1, minute: 1, minuten: 1,
    h: 60, std: 60, 'std.': 60, stunde: 60, stunden: 60,
    t: 'day', tag: 'day', tage: 'day', tagen: 'day',
  },
  recurrenceLeads: ['jeden', 'jede', 'jedes', 'jeder', 'alle', 'täglich', 'wöchentlich', 'monatlich', 'jährlich', 'werktags'],
  weekdayShort: ['mo', 'di', 'mi', 'do', 'fr', 'sa', 'so'],
  prepositions: ['am'],
  periodNouns: ['vormittag', 'mittag', 'nachmittag', 'abend'],
  periodWords: { ...PERIOD_KEYWORDS, morgens: 'morning' },
  periodAdverbs: { morgens: 'morning', vormittags: 'morning', mittags: 'noon', nachmittags: 'afternoon', abends: 'evening' },
}
